'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _views = require('../constants/views');

var initialState = _views.THREAD_LIST;

var currentView = (0, _reduxActions.handleAction)(_actionTypes.UPDATE_VIEW, function (state, action) {
  var view = action.payload.view;


  return view;
}, initialState);

exports.default = currentView;
module.exports = exports['default'];